var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 11.9138L18.6193 6.29381C18.7599 6.14794 18.8368 5.9522 18.833 5.74966C18.8293 5.54712 18.7452 5.35437 18.5993 5.21381C18.4535 5.07324 18.2577 4.99638 18.0552 5.00013C17.8527 5.00388 17.6599 5.08794 17.5193 5.23381L11.8993 10.8538L6.27934 5.23381C6.13717 5.10133 5.94912 5.0292 5.75482 5.03263C5.56052 5.03606 5.37513 5.11477 5.23772 5.25218C5.10031 5.3896 5.02159 5.57498 5.01817 5.76928C5.01474 5.96359 5.08686 6.15163 5.21934 6.29381L10.8393 11.9138L5.21934 17.5338C5.07889 17.6744 5 17.8651 5 18.0638C5 18.2626 5.07889 18.4532 5.21934 18.5938C5.35997 18.7343 5.55059 18.8131 5.74934 18.8131C5.94809 18.8131 6.13871 18.7343 6.27934 18.5938L11.8993 13.0138L17.5193 18.6338C17.66 18.7743 17.8506 18.8531 18.0493 18.8531C18.2481 18.8531 18.4387 18.7743 18.5793 18.6338C18.7198 18.4932 18.7987 18.3026 18.7987 18.1038C18.7987 17.9051 18.7198 17.7144 18.5793 17.5738L12.9993 11.9138Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.2dccdd73f989d1baf681da76e053a1d2.svg";
export { ForwardRef as ReactComponent };